<template>
  <div class="popularize-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <el-tree :props="props" :load="loadNode" lazy icon-class="">
          <div slot-scope="{ node, data }">
            <div class="row">
              <img
                class="pic"
                :src="static + 'popularize-01.svg'"
                alt=""
                v-if="data.way === 0"
              />
              <p v-else>
                <img
                  class="pic pic2"
                  v-if="!node.expanded"
                  :src="static + 'popularize-02.svg'"
                  alt=""
                />
                <img
                  class="pic pic2"
                  v-else
                  :src="static + 'popularize-03.svg'"
                  alt=""
                />
              </p>
              <span>编号：{{ data.uid }}</span>
              <span>姓名：{{ data.nickname }}</span>
              <span>等级：{{ roleMap[data.roleTypeOne] }}</span>
              <span>团队业绩：{{ data.teamKpi }}</span>
            </div>
          </div>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
import { role, roleMap, staticImg } from '@/config.js';
export default {
  components: {
    Header
  },
  name: 'popularize',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '用户推广信息'
      },
      info: {},
      static: staticImg,
      roleList: [
        {
          name: '全部',
          id: -1
        },
        {
          name: '消费者',
          id: 0
        },
        ...role
      ],
      roleMap: {},
      list: [],
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      }
    };
  },
  mounted() {
    // 获取列表
    let query = this.$route.query;
    this.getDictionary();
    if (query.uid) {
      this.info = query;
    }
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {},
  methods: {
    loadNode(node, resolve) {
      if (node.level === 0) {
        let query = this.$route.query;
        if (query.uid) {
          this.info = query;
        }
        return resolve([this.info]);
      }
      // console.log(node.data.uid);
      // return;
      this.httpGet(this.$root.getUserTree, {
        uid: node.data.uid
      }).then(
        (res) => {
          let list = res.list.map(item => {
            return {
              ...item,
              leaf: item.way === 0
            };
          });
          resolve(list);
        },
        (res) => {
          this.$message.error(res);
        }
      );
    },
    // 获取留言板列表
    getList(uid) {
      // return;
      this.loading++;
      this.httpGet(this.$root.getUserTree, {
        uid
      }).then(
        (res) => {
          this.loading--;
          return res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('role');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          // this[dataName] = res.list; 
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

>>>.el-icon-caret-right {
  display: none;
}

.popularize-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // background: #fff

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .row {
        height: 30px;
        line-height: 30px;
        flex-x(flex-start);

        p {
          flex-x(flex-start);
        }

        .pic {
          height: 18px;
          width: 18px;
          margin-right: 3px;
        }

        .pic2 {
          cursor: pointer;
        }

        span {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
